export const PREFERENCES_REASON_OPTIONS = [
  { title: 'Relaxation', selected: false },
  { title: 'Stress Relief', selected: false },
  { title: 'Pain Reduction', selected: false },
  { title: 'Health & Wellness', selected: false },
  { title: 'Sports Recovery', selected: false },
  { title: 'Pregnancy', selected: false },
];

export const PREFERENCES_BACK_OPTIONS_MINI = [
  {
    title: 'Head',
    key: 'head',
    apiKey: 'focus_backside_head',
    apiPKey: 'pressure_backside_head',
  },
  {
    title: 'Neck',
    key: 'neck',
    apiKey: 'focus_backside_neck',
    apiPKey: 'pressure_backside_neck',
  },
  {
    title: 'Shoulders',
    key: 'shoulders',
    apiKey: 'focus_backside_shoulders',
    apiPKey: 'pressure_backside_shoulders',
  },
  {
    title: 'Upper Back',
    key: 'upperback',
    apiKey: 'focus_backside_upper-back',
    apiPKey: 'pressure_backside_upper-back',
  },
  {
    title: 'Arms, Hands',
    key: 'arms',
    apiKey: 'focus_frontside_arms-hands',
    apiPKey: 'pressure_frontside_arms-hands',
  },
  {
    title: 'Feet',
    key: 'feet',
    apiKey: 'focus_frontside_feet',
    apiPKey: 'pressure_frontside_feet',
  },
];

export const PREFERENCES_BACK_OPTIONS = [
  {
    title: 'Neck',
    key: 'neck',
    apiKey: 'focus_backside_neck',
    apiPKey: 'pressure_backside_neck',
  },
  {
    title: 'Shoulders',
    key: 'shoulders',
    apiKey: 'focus_backside_shoulders',
    apiPKey: 'pressure_backside_shoulders',
  },
  {
    title: 'Upper Back',
    key: 'upperback',
    apiKey: 'focus_backside_upper-back',
    apiPKey: 'pressure_backside_upper-back',
  },
  {
    title: 'Lower Back',
    key: 'lowerback',
    apiKey: 'focus_backside_lower-back',
    apiPKey: 'pressure_backside_lower-back',
  },
  {
    title: 'Hip & Glutes',
    key: 'hips',
    apiKey: 'focus_backside_hips-glutes',
    apiPKey: 'pressure_backside_hips-glutes',
  },
  {
    title: 'Hamstrings',
    key: 'hams',
    apiKey: 'focus_backside_hamstrings',
    apiPKey: 'pressure_backside_hamstrings',
  },
  {
    title: 'Calves',
    key: 'calves',
    apiKey: 'focus_backside_calves',
    apiPKey: 'pressure_backside_calves',
  },
];

export const PREFERENCES_FRONT_OPTIONS = [
  {
    title: 'Head',
    apiKey: 'focus_frontside_head',
    apiPKey: 'pressure_frontside_head',
    key: 'head',
  },
  {
    title: 'Face & Jaw',
    apiKey: 'focus_frontside_face-jaw',
    apiPKey: 'pressure_frontside_face-jaw',
    key: 'face',
  },
  {
    title: 'Pecs',
    apiKey: 'focus_frontside_pecs',
    apiPKey: 'pressure_frontside_pecs',
    key: 'pecs',
  },
  {
    title: 'Arms, Hands',
    apiKey: 'focus_frontside_arms-hands',
    apiPKey: 'pressure_frontside_arms-hands',
    key: 'arms',
  },
  {
    title: 'Quads',
    apiKey: 'focus_frontside_quads',
    apiPKey: 'pressure_frontside_quads',
    key: 'quads',
  },
  {
    title: 'Feet',
    apiKey: 'focus_frontside_feet',
    apiPKey: 'pressure_frontside_feet',
    key: 'feet',
  },
];

/** Top-row preferences on booking add-ons page (apiKey must match `/user/preferences`). */
export const BOOKING_ADDONS_PAGE_PREFERENCE_API_KEYS = [
  'heat_therapy',
  'percussion_therapy',
  'aromatherapy',
];

/** Service preferences persisted during booking; apiKey must match `/user/preferences`. */
export const BOOKING_SERVICE_PREFERENCE_OPTIONS = [
  {
    title: 'Heat therapy?',
    apiKey: 'heat_therapy',
    values: [
      { title: 'yes', selected: false, value: 1 },
      { title: 'no', selected: false, value: 0 },
    ],
    modalTitle: 'WHAT IS HEAT THERAPY?',
    modalText:
      'Heat therapy is the application of heat pads to areas of the body with tense muscles and localized pain in order to increase blood-flow, soften tissues in preparation for massage, and promote relaxation',
    modelSegment: 'Heat Therapy Tooltip',
  },
  {
    title: 'Percussion therapy?',
    apiKey: 'percussion_therapy',
    values: [
      { title: 'yes', selected: false, value: 'Yes' },
      { title: 'no', selected: false, value: 'No' },
    ],
    modalTitle: 'WHAT IS PERCUSSION THERAPY?',
    modalText:
      'Using a handheld massage gun, percussion therapy sends strong pulses and vibrations into the muscle tissue to loosen tight muscles, increase blood flow, and improve range of motion in a targeted manner, allowing for a deeper, more effective massage.',
    modelSegment: 'Percussion Therapy Tooltip',
  },
  {
    title: 'Aromatherapy?',
    apiKey: 'aromatherapy',
    values: [
      { title: 'yes', selected: false, value: 1 },
      { title: 'no', selected: false, value: 0 },
    ],
    modalTitle: 'AROMATHERAPY',
    modalText:
      'Scent and essential oils during your session. You can finalize your scent when you arrive at the studio.',
    modelSegment: 'Aromatherapy Tooltip',
  },
];

/** Shown on pressure step, not on add-ons page; drives hidden deep-tissue add-on for scheduling. */
export const BOOKING_DEEP_TISSUE_PREFERENCE = {
  title: 'Deep tissue?',
  apiKey: 'deep_tissue',
  values: [
    { title: 'yes', selected: false, value: 1 },
    { title: 'no', selected: false, value: 0 },
  ],
  modalTitle: 'DEEP TISSUE',
  modalText:
    'Extra focus on deeper muscle layers and areas of tension during your massage.',
  modelSegment: 'Deep Tissue Tooltip',
};

export const BOOKING_ADDONS_PAGE_PREFERENCE_OPTIONS =
  BOOKING_SERVICE_PREFERENCE_OPTIONS.filter(opt =>
    BOOKING_ADDONS_PAGE_PREFERENCE_API_KEYS.includes(opt.apiKey),
  );

export const PREFERENCES_EXTRAS = [
  {
    title: 'Oil or lotion?',
    apiKey: 'oil_lotion',
    values: [
      { title: 'oil', value: 'OIL' },
      { title: 'lotion', value: 'LOTION', selected: true },
    ],
    modalTitle: 'OILS AND LOTIONS',
    modalText: 'All our oils and lotions are natural and paraben-free.',
    modelSegment: 'Oil Lotion Tooltip',
  },
  {
    title: 'Table heated?',
    apiKey: 'heated_bed',
    values: [
      { title: 'yes', selected: true, value: 1 },
      { title: 'no', value: 0 },
    ],
    modalTitle: 'HEATED TABLE',
    modalText:
      "If you select yes, your table will be set to medium heat (our most preferred heat setting). Your therapist will check-in with you a few minutes into your massage to see if you want more, less or if it's just right.",
    modelSegment: 'Bed Heated Tooltip',
  },
  {
    title: 'Heat therapy?',
    apiKey: 'heat_therapy',
    values: [
      { title: 'yes', selected: true, value: 1 },
      { title: 'no', value: 0 },
    ],
    modalTitle: 'WHAT IS HEAT THERAPY?',
    modalText:
      'Heat therapy is the application of heat pads to areas of the body with tense muscles and localized pain in order to increase blood-flow, soften tissues in preparation for massage, and promote relaxation',
    modelSegment: 'Heat Therapy Tooltip',
  },
  {
    title: 'Percussion therapy?',
    apiKey: 'percussion_therapy',
    values: [
      { title: 'yes', selected: true, value: 'Yes' },
      { title: 'no', value: 'No' },
    ],
    modalTitle: 'WHAT IS PERCUSSION THERAPY?',
    modalText:
      'Using a handheld massage gun, percussion therapy sends strong pulses and vibrations into the muscle tissue to loosen tight muscles, increase blood flow, and improve range of motion in a targeted manner, allowing for a deeper, more effective massage.',
    modelSegment: 'Percussion Therapy Tooltip',
  },
];

export const PREFERENCES_DROPDOWN_OPTIONS = [
  { value: 'USUAL', label: 'USUAL', color: '#333333' },
  { value: 'MORE', label: 'MORE', color: '#37777e' },
  { value: 'AVOID', label: 'AVOID', color: '#e57373' },
];

export const PREFERENCES_DROPDOWN_OPTIONS_PRESSURE = [
  { value: 'USUAL', label: 'USUAL', color: '#8dd1d8' },
  { value: 'MORE', label: 'MORE', color: '#37777e' },
  { value: 'LESS', label: 'LESS', color: '#bbeef3' },
];

export const LOCATION_STATE = { CA: 'CALIFORNIA' };
